import { Clickable, Col, Icon, Row, Sidepanel, Text } from 'components';
import { subDays } from 'date-fns';
import { Api, closeNotifs, filterNotifs, theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Notification } from './components';

const FilterItem = ({ text, filter, handleFilters, filters }) => {
  const selected = filters.includes(filter);

  return (
    <Clickable onClick={() => handleFilters(filter)}>
      <Row pad="2px 24px" bg={selected ? theme.SECONDARY : theme.GREY_10} hasRadius="32px">
        <Text b1 med col={selected ? '#fff' : '#000'}>
          {text}
        </Text>
      </Row>
    </Clickable>
  );
};

const Notifications = (prop) => {
  const [filters, setFilters] = useState([]),
    [data, setData] = useState([]),
    notifications = useSelector((state) => state.notifications),
    { showNotifications, isMobile } = useSelector((state) => state.appState),
    currentUser = useSelector((state) => state.user),
    dispatch = useDispatch(),
    { t } = useTranslation();

  const now = new Date();
  const dayBeforeYesterday = subDays(now, 2);

  useEffect(() => {
    const today = {
      title: 'common.today',
      data: filterNotifs('isToday')
    };

    const yesterday = {
      title: 'common.yesterday',
      data: filterNotifs('isYesterday')
    };

    const earlier = {
      title: 'common.earlier',
      data: filterNotifs('isBeforeYesterday')
    };

    setData([today, yesterday, earlier]);
  }, [notifications]);

  function handleFilters(filter) {
    if (filters.includes(filter)) return setFilters(filters.filter((x) => x !== filter));

    setFilters([...filters, filter]);
  }

  useEffect(() => {
    if (showNotifications) {
      Api.post('/users/markNotifsRead');

      dispatch({
        type: 'MARK_ALL_NOTIFS_READ',
        payload: null
      });
    }
  }, [showNotifications]);

  return (
    <Sidepanel
      visible={showNotifications}
      closeModal={() => closeNotifs(dispatch)}
      isMobile={isMobile}
      wid={456}
      title={
        <Col noFlex>
          <Row between center ht="66px" marg="10px 0 0" pad={isMobile ? '16px' : '0 24px'}>
            <Text h2>Notifications</Text>

            <Clickable onClick={() => closeNotifs(dispatch)}>
              <Icon type="close" col={theme.GREY_60} dimensions={14} />
            </Clickable>
          </Row>

          <Row marg="0 0 16px 16px" gap="8px" start>
            <FilterItem
              text="Reactions"
              filter="Reaction"
              handleFilters={handleFilters}
              filters={filters}
            />

            <FilterItem
              text="Games"
              filter="game"
              handleFilters={handleFilters}
              filters={filters}
            />

            <FilterItem
              text="One-on-one"
              filter="connect"
              handleFilters={handleFilters}
              filters={filters}
            />
          </Row>
        </Col>
      }
    >
      <Col start>
        {(() => {
          const sections = data
            .map((x) => ({
              ...x,
              notifs: x.data?.filter((n) => {
                for (var y of filters) {
                  if (n.type.includes(y)) return true;
                }

                return !filters.length;
              })
            }))
            .filter((x) => x.notifs?.length);
    
          if (!sections.length) {
            return (
              <Col centerAll noFlex wid="100%" pad="64px 24px" gap="8px">
                <Icon type="notificationOutline" col={theme.GREY_40} dimensions={28} />
                <Text h4 col={theme.GREY_70} marg="8px 0 0">
                  {t('notifications.noNotificationsTitle')}
                </Text>
                <Text b2 col={theme.GREY_60} center>
                  {t('notifications.noNotifications')}
                </Text>
              </Col>
            );
          }

          return sections.map((x, i) => (
            <Col marg="0 0 16px" key={i} noFlex wid="100%">
              <Text h4 marg="0 0 12px">
                {t(x.title)}
              </Text>

              {x.notifs.map((y, i) => (
                <Notification key={i} item={y} section={x} />
              ))}
            </Col>
          ));
        })()}
      </Col>
    </Sidepanel>
  );
};

export default Notifications;
